<template>
  <div class="campaign-coverage">
    <div>
      <a-table :columns="columnsTable" size="middle" :data-source="data" row-key="group_name">
        <template #expandedRowRender="{ record }">
          <table>
            <caption style="display: none">
              tabla de resultados
            </caption>
            <th id="thempty" style="display: none"></th>

            <tr v-for="(item, index) in record.results" :key="index">
              <td id="empty" style="width: 43%" />
              <td id="result" style="width: 40%">{{ item.result }}</td>
              <td id="total">{{ item.total }}</td>
            </tr>
          </table>
        </template>
      </a-table>
    </div>
    <div class="chart-div"><line-chart-campaign :data="graphicData" /></div>
  </div>
</template>
<script>
import { defineComponent, computed } from "vue";
import { columnsFixedTableLeft } from "@/app/shared/utils/columnTable";
import lineChartCampaign from "./lineChartCampaign.vue";
const headers = [
  {
    title: "Tipo de contacto",
    key: "group_name",
    dataIndex: "group_name",
    width: 100,
  },
  {
    title: "Resultado",
    dataIndex: "grandTotal",
    width: 100,
  },
  {
    title: "Cantidad",
    key: "total",
    dataIndex: "total",
    width: 50,
  },
];
export default defineComponent({
  components: {
    lineChartCampaign,
  },
  props: {
    dataTable: {
      type: Array,
      required: true,
    },
    graphicData: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const data = computed(() => props.dataTable);
    const columnsTable = computed(() => columnsFixedTableLeft(headers));
    return {
      columnsTable,
      data,
    };
  },
});
</script>

<style lang="sass" scoped>
.campaign-coverage
    display: grid
    grid-template-columns: 0.8fr 1.2fr
    gap: 25px
td, th
    border-bottom: 1px solid #dddddd
    text-align: left
    padding: 8px 10px
table
    margin-top: -10px
    margin-bottom: -11px
.chart-div
    padding-right: 10px
</style>
